import { createElement } from 'react';
import { Route } from 'react-router';

export default (path, component, opts = {}) =>
  () =>
    createElement(Route, { path, component, ...opts });
